export default function (objAddr) {
  let arrAddr = [];
  if (objAddr.address1) arrAddr.push(objAddr.address1);
  if (objAddr.address2) arrAddr.push(objAddr.address2);
  if (objAddr.city) arrAddr.push(objAddr.city);
  if (objAddr.zip) arrAddr.push(objAddr.zip);
  if (objAddr.country) arrAddr.push(objAddr.country);
  return arrAddr.join(', ');
}
